/**
 * TrendingSection — momentum-ranked creator leaderboard on HomeFeed (GL4).
 *
 * Pulls `/api/clans/trending` (public, no auth). Renders a horizontal-scrolling
 * row of momentum cards. Hidden entirely when there's nothing trending — better
 * to show nothing than a stale empty state.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export default function TrendingSection() {
  const navigate = useNavigate();
  const [clans, setClans] = useState(null);

  useEffect(() => {
    api.get('/clans/trending?limit=8')
      .then((r) => setClans(r.data?.clans || []))
      .catch(() => setClans([]));
  }, []);

  if (!clans || clans.length === 0) return null;

  return (
    <div style={{ marginBottom: 32 }} data-testid="trending-section">
      <div className="section-head" style={{ marginBottom: 12 }}>
        <span className="section-title" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span>🚀 Momentum</span>
          <span
            style={{
              fontSize: 11, padding: '2px 8px', borderRadius: 999,
              background: 'rgba(255,87,34,0.15)',
              border: '1px solid rgba(255,87,34,0.4)',
              color: '#FF5722', fontWeight: 700,
            }}
          >
            LIVE
          </span>
        </span>
      </div>
      <div
        style={{
          display: 'grid',
          gridAutoFlow: 'column',
          gridAutoColumns: 'minmax(240px, 1fr)',
          gap: 12,
          overflowX: 'auto',
          paddingBottom: 8,
          scrollSnapType: 'x mandatory',
        }}
      >
        {clans.map((c) => (
          <div
            key={c.handle}
            onClick={() => navigate(`/clan/${c.handle}/feed`, { state: { from: '/home' } })}
            style={{
              cursor: 'pointer', padding: 14, borderRadius: 14,
              background: `linear-gradient(135deg, ${c.gradient[0]}22, ${c.gradient[1]}22)`,
              border: '1px solid rgba(255,87,34,0.3)',
              scrollSnapAlign: 'start',
              transition: 'transform 0.15s',
            }}
            data-testid={`trending-card-${c.handle}`}
            onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-2px)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
              {c.avatar ? (
                <img src={c.avatar} alt="" style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover' }} />
              ) : (
                <div
                  style={{
                    width: 40, height: 40, borderRadius: '50%',
                    background: `linear-gradient(135deg, ${c.gradient[0]}, ${c.gradient[1]})`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontWeight: 700, color: '#fff', fontSize: 14,
                  }}
                >
                  {c.display_name.split(' ').map((w) => w[0]).slice(0, 2).join('').toUpperCase()}
                </div>
              )}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 14, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                  {c.display_name}
                  {c.verified && <span style={{ marginLeft: 4, color: '#00B4FF' }}>✓</span>}
                </div>
                <div style={{ fontSize: 11, opacity: 0.65 }}>@{c.handle}</div>
              </div>
            </div>
            <div
              style={{
                display: 'inline-block', padding: '3px 8px', borderRadius: 999,
                background: 'rgba(255,87,34,0.15)', border: '1px solid rgba(255,87,34,0.4)',
                color: '#FF5722', fontSize: 11, fontWeight: 700, marginBottom: 6,
              }}
            >
              🔥 +{c.pct_7d}% this week
            </div>
            <div style={{ fontSize: 11, opacity: 0.75, marginTop: 4 }}>
              {c.followers.toLocaleString()} on {c.best_platform.toUpperCase()} · Bit ${c.current_price}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
